<template>
    <div class="clients-list__item new-item new-item--high"
         @click="openDialog()">
        <i class="material-icons new-item__icon">add_box</i>
        <h2 class="new-item__title">New client</h2>
    </div>
</template>

<script>
    export default {
        name: "ClientsListNewItemButton",
        methods: {
            openDialog: function ($e) {
                this.$emit('dialogOpened', $e)
            }
        }
    }
</script>

<style scoped>

</style>
